// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".onefold-table[data-v-2e8162f1]:not(:last-child){margin-bottom:40px}.onefold-table table[data-v-2e8162f1]{width:100%}.onefold-table table tr[data-v-2e8162f1]{display:flex}.onefold-table table tr td[data-v-2e8162f1]{padding-left:10px;padding-right:10px}.onefold-table table tr td[data-v-2e8162f1]:nth-child(2n-1){width:20%;background:#f9f9f9;text-align:center}.onefold-table table tr td[data-v-2e8162f1]:nth-child(2n){flex:2}", ""]);
// Exports
module.exports = exports;
